<section id="image-container">
    <div id="top-row"><button mat-icon-button (click)="closeImageViewer()"><mat-icon svgIcon="close"></mat-icon></button></div>
    <img id="display-image" [src]="imgURL" />
</section>